import './App.css'
import React, { useEffect, useState } from 'react'
import { ThemeProvider, createTheme, Box } from '@mui/material'
import CssBaseline from '@mui/material/CssBaseline'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Home from './pages/home'
import Navbar from './components/navbar'
import DetailsPage from './pages/destination_details'
import Footer from './components/footer'
import About from './pages/about'
import ServicesD from './pages/services_d'
import Contact from './pages/contact'
import ScrollTop from './components/scroll_top'
import LoadingScreen from './components/loading'
const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#327d81',
    },
    secondary: {
      main: '#13294b',
    },
    background: {
      default: 'transparent',
      paper: '#1a2027',
    },
    text: {
      primary: '#000000',
      secondary: '#f4f6ef',
    },
  },
  typography: {
    fontFamily: 'Montserrat',
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(26, 32, 39, 0.8)',
          backdropFilter: 'blur(0px)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
})
function App() {
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Simulate an async operation (e.g., fetching data)
    setTimeout(() => setLoading(false), 3000)
  }, [])
  return loading ? (
    <LoadingScreen />
  ) : (
    <Router>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <ScrollTop />
        <Navbar />
        <Box
          sx={{
            margin: 0,
            padding: 0,

            width: '100%',
            minWidth: '100%',
            overflow: 'hidden',
            bgcolor: 'background.default',
            color: 'text.primary',
            '& > section': {
              minHeight: '100vh',
              display: 'flex',
              alignItems: 'center',
              scrollMarginTop: '64px',
            },
          }}
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<ServicesD />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/details/:index" element={<DetailsPage />} />
          </Routes>

          <Footer />
        </Box>
      </ThemeProvider>
    </Router>
  )
}

export default App
